module.exports = __webpack_public_path__ + "img/1.c169f0f1.jpg";